import { Component } from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';
import {URLSearchParams} from '@angular/http';
import { Router } from '@angular/router';
import {ApiService} from '../../_services/api.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html'
})
export class AppHeaderComponent { 
    constructor(private http: Http,private apiService: ApiService,private router: Router) {
    }
    userdata = [];
    ngOnInit(): void {

              this.apiService.http_get('/admin').subscribe(
          (result) =>{
          this.userdata = result.json()[0];

          }
        )

    }

    logout(): void {
        // clear token remove user from local storage to log user out
        localStorage.clear();
        this.router.navigateByUrl('/admin/login');
    }
}



// WEBPACK FOOTER //
// /var/www/html/LASO/laso-client/src/app/components/app-header/app-header.component.ts